import { redirect } from "@tanstack/solid-router";

export function throwOrRedirect(
  redirectToOnError?: string,
  errorMessage?: string
) {
  if (redirectToOnError) {
    throw redirect({
      to: redirectToOnError,
    });
  } else {
    throw new Error(errorMessage);
  }
}
